class WheelCarousel {

    constructor(stickyBoxId, stickyId, wheelCarouselId,offsetRate = 0.1) {



        this.stickyBox = document.getElementById(stickyBoxId);

        this.sticky = document.getElementById(stickyId);

        this.wheelCarousel = document.getElementById(wheelCarouselId);

        this.wheelCarouselItems = this.wheelCarousel.children

        if (offsetRate > 0 || offsetRate < 1){
            this.offsetRate = offsetRate
        } else if (offsetRate <= 0){
            this.offsetRate = 0
        } else {
            this.offsetRate = 1
        }

        if (this.wheelCarouselItems.length > 0) {
            this.init();
        }
    }

    init() {

        const viewportWidth = document.documentElement.clientWidth;

        for (let item of this.wheelCarouselItems) {
            item.style.minWidth = `${viewportWidth}px`;
            item.style.maxWidth = `${viewportWidth}px`;
        }

        const totalWidth = (this.wheelCarouselItems.length - 1) * viewportWidth; // 减去一个高度

        this.wheelCarousel.style.width = `${totalWidth}px`;

        let height = Math.ceil(document.getElementById('newHead').offsetHeight);

        let newHead = document.getElementById('newHead');

        this.newHead = newHead

        this.sticky.style.top = height + 'px'

        for (let item of this.wheelCarouselItems) {
            item.style.height = window.innerHeight - height + 'px'
        }

        this.addClass()
    }

    addClass() {

        this.sticky.classList.add('wheel-carousel-sticky')

        this.stickyBox.classList.add('wheel-carousel-sticky-box')

        this.wheelCarousel.classList.add('wheel-carousel')

        for (let item of this.wheelCarouselItems) {
            item.classList.add('wheel-carousel-item')
        }

        this.listener();

    }


    listener() {

        window.addEventListener('scroll', () => {
            const newHead = this.newHead;
            const stickyElement = this.sticky
            const stickyBoxElement = this.stickyBox

            // 获取 newHead 的底部位置
            const newHeadRect = newHead.getBoundingClientRect();
            const newHeadBottom = newHeadRect.bottom;

            // 获取 stickyElement 的位置信息
            const stickyRect = stickyElement.getBoundingClientRect();
            const stickyTop = stickyRect.top;
            const stickyBottom = stickyRect.bottom;

            // 获取视口高度
            const viewportHeight = window.innerHeight;

            let rate

            if (stickyTop < newHeadBottom) {
                rate = 100
            } else if (stickyBottom > viewportHeight) {
                rate = 0
            } else {

                const scrollY = window.scrollY

                const newHeadHeight = newHead.offsetHeight;

                let n = (scrollY - stickyBoxElement.offsetTop + newHeadHeight);

                let d = (stickyBoxElement.offsetHeight - window.innerHeight + newHeadHeight);

                let offset = d * this.offsetRate;

                if (n >= offset && n <= d - offset) {
                    rate = (n - offset) / (d - offset * 2) * 100
                } else if (n < offset) {
                    rate = 0
                } else {
                    rate = 100
                }
            }

            this.wheelCarousel.style.transform = `translateX(-${rate}%)`;



        });

    }



}



